import { prop, propOr } from 'ramda';
import { createSelector } from 'reselect';

import { NAME } from './constants';

const getRoot = prop(NAME);

export const getTaskPartners = createSelector(getRoot, propOr([], 'partners'));
